import React from 'react';
import Star from '../../../static/assets/svg/Star.svg';
import './Rating.scss';

const Rating = ({ rating, totalNoOfRatings, customStyles = {}, iconStyle = {} }) => {
  return (
    <div
      className={`new-rating display-ib ${rating === 0 ? 'rating-block' : ''}`}
      style={customStyles}
    >
      {rating > 0 && (
        <div>
          <span className="rating-value">{Math.round(rating * 10) / 10}</span>
          <span className="rating-icon">
            <img src={Star} alt="rating-star" style={iconStyle}></img>
          </span>
          <span className="rating-count">{totalNoOfRatings}</span>
        </div>
      )}
    </div>
  );
};

export default Rating;
